{
  "page": {
    "title": "Alertas de snipe",
    "subtitle": "Recibe mensajes directos de Discord cuando los objetos, mascotas o WoW Token que vigilas aparezcan en la casa de subastas por debajo de tu precio objetivo."
  },
  "discordRequired": {
    "title": "Discord requerido",
    "description": "Necesitas vincular tu cuenta de Discord antes de poder configurar las alertas de snipe. Las alertas se envían como mensajes directos de Discord.",
    "linkButton": "Ir a ajustes para vincular Discord"
  },
  "loading": "Cargando...",
  "notifications": {
    "title": "Notificaciones de snipe",
    "description": "Recibe alertas cuando objetos o mascotas vigilados se encuentren por debajo de tu precio objetivo."
  },
  "alertStyle": {
    "title": "Estilo de alerta",
    "subtitle": "Elige cómo se muestran las notificaciones de Discord.",
    "compact": "Compacto",
    "compactDescription": "Embeds solo de texto, sin miniaturas. Más alertas por mensaje.",
    "detailed": "Detallado",
    "detailedDescription": "Embeds enriquecidos con miniaturas de objetos. Un embed por objeto."
  },
  "cooldown": {
    "title": "Tiempo de espera de alertas",
    "subtitle": "Cuántos ciclos de actualización de la casa de subastas (aprox. 1 hora cada uno) se omiten antes de volver a alertar sobre la misma subasta. 0 = alertar en cada actualización.",
    "cycles": "ciclo(s)",
    "save": "Guardar",
    "saving": "Guardando..."
  },
  "realms": {
    "title": "Reinos a monitorear",
    "subtitle": "Selecciona los reinos {{region}} a vigilar para oportunidades de snipe.",
    "placeholder": "Selecciona los reinos a monitorear",
    "removeRussian": "Eliminar todos los reinos rusos",
    "saveButton": "Guardar reinos",
    "savingButton": "Guardando..."
  },
  "addEdit": {
    "addTitle": "Agregar snipe {{type}}",
    "editTitle": "Editar snipe {{type}}",
    "typeLabel": "Tipo",
    "typeItem": "Objeto",
    "typePet": "Mascota",
    "typeToken": "Token",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Nombre del objeto",
    "petNameLabel": "Nombre de mascota o ID",
    "tokenLabel": "Token",
    "searchPlaceholder": "Buscar un objeto...",
    "petPlaceholder": "Ingresa el ID de mascota (ej. 3390) o busca por nombre...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9,999,999g 99s",
    "targetPriceLabel": "Precio objetivo",
    "pricePlaceholder": "ej. 500g o 500g 50s",
    "ilvlMinLabel": "ilvl mín",
    "ilvlMaxLabel": "ilvl máx",
    "optional": "(opc)",
    "sockets": "Engarces",
    "secondaryStats": "Atributos Secundarios",
    "secondaryStatsHint": "(opcional, elige hasta 2)",
    "statCrit": "Crit.",
    "statHaste": "Prest.",
    "statVersatility": "Versatilidad",
    "statMastery": "Maestría",
    "noItemsFound": "No se encontraron objetos",
    "noPetsFound": "No se encontraron mascotas",
    "anyItem": "Cualquier objeto",
    "addButton": "Agregar {{type}}",
    "updateButton": "Actualizar {{type}}",
    "addTokenButton": "Agregar alerta de Token",
    "updateTokenButton": "Actualizar alerta de Token",
    "cancelEdit": "Cancelar edición",
    "remove": "Eliminar",
    "nounItem": "objeto",
    "nounPet": "mascota",
    "categoryLabel": "Categoría",
    "statSpeed": "Velocidad",
    "statLeech": "Robo de vida",
    "statAvoidance": "Evasión"
  },
  "importExport": {
    "importButton": "Importar JSON de {{label}}",
    "importingButton": "Importando...",
    "exportIlvlButton": "Exportar JSON de objetos ilvl",
    "exportButton": "Exportar JSON de {{label}}",
    "clearAllButton": "Borrar todos {{label}} ({{count}})",
    "pasteHint": "Tip: Presiona Ctrl+V (o Cmd+V en Mac) en cualquier parte de esta página para pegar e importar un archivo JSON directamente.",
    "clearAllTitle": "Borrar todos: {{label}}",
    "clearAllConfirmButton": "Borrar todo"
  },
  "tabs": {
    "items": "Objetos",
    "ilvlItems": "Objetos ilvl",
    "pets": "Mascotas",
    "token": "WoW Token"
  },
  "table": {
    "filterPlaceholder": "Filtrar por nombre de objeto o ID...",
    "countAll": "{{count}} regla(s) ilvl",
    "countFiltered": "{{filtered}} de {{total}} reglas ilvl",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} de {{total}} {{noun}}",
    "colItems": "Objetos",
    "colIlvl": "ilvl",
    "colStats": "Estadísticas",
    "colBuyout": "Compra directa",
    "colActions": "Acciones",
    "colTargetPrice": "Precio objetivo",
    "editButton": "Editar",
    "duplicateButton": "Duplicar",
    "deleteButton": "Eliminar",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Busca un objeto arriba o importa un archivo JSON para empezar.",
    "emptyHintPets": "Ingresa un ID de mascota arriba o importa un archivo JSON para empezar.",
    "emptyHintToken": "Establece un precio objetivo arriba para recibir una notificación cuando la ficha de WoW baje de ese valor.",
    "emptyHintIlvl": "Define límites de nivel de objeto arriba o importa un archivo JSON para empezar.",
    "nounItems": "objeto(s)",
    "nounPets": "mascota(s)",
    "nounToken": "alerta de token",
    "nounIlvl": "regla(s) de ilvl",
    "loadingName": "Cargando...",
    "colCategory": "Categoría",
    "percentLoaded": "{{percent}}% cargado",
    "editPrice": "Editar precio",
    "inlineEditHint": "Haz clic para editar — Enter guarda, Esc cancela"
  },
  "personalConfig": {
    "title": "Configuración personal de filtros",
    "subtitle": "Ajusta los filtros a continuación para establecer tus preferencias predeterminadas. Se aplicarán automáticamente cuando uses las herramientas de subasta.",
    "tip": "💡 Consejo: ajusta los filtros como quieras y luego haz clic en \"Guardar como predeterminados\" para que sean tus ajustes permanentes.",
    "livePreviewTitle": "Vista previa de filtros en vivo",
    "livePreviewSubtitle": "Estos son los filtros reales de la herramienta de subasta. Establece tus valores predeterminados según sea necesario:",
    "saveButton": "Guardar filtros predeterminados",
    "resetToSavedButton": "🔄 Restablecer a mis predeterminados guardados",
    "resetToSystemButton": "⚙️ Restablecer a los predeterminados del sistema",
    "needHelp": "¿Necesitas ayuda con la configuración? Únete a nuestro Discord",
    "dashboardSection": "Filtro de Oportunidades del Panel",
    "dashboardSectionSubtitle": "Establece el rango de precio de compra directa para los artículos mostrados en el widget de Mejores Oportunidades del panel.",
    "dashboardBuyoutMin": "Compra Mín. (Oro)",
    "dashboardBuyoutMax": "Compra Máx. (Oro)",
    "dashboardBuyoutMaxHint": "Pon 0 para no tener máximo",
    "dashboardSaveButton": "Guardar Configuración del Panel",
    "itemMatchingSection": "Configuración de clave de artículo",
    "itemMatchingSectionSubtitle": "Controla cómo se comparan las variantes de artículos entre reinos al calcular oportunidades.",
    "ignoreStatsBeforeExpansion": "Ignorar estadísticas secundarias antes de esta expansión",
    "ignoreStatsBeforeExpansionHint": "Los artículos de expansiones anteriores a la seleccionada se tratarán como idénticos independientemente de su sufijo de estadística secundaria. Útil para artículos de expansiones antiguas donde las diferencias de estadísticas no afectan al valor de reventa.",
    "ignoreStatsNone": "Ninguno (desactivado)",
    "itemMatchingSaveButton": "Guardar configuración de artículos"
  },
  "inventoryAnalysis": {
    "premiumRequired": "¡Necesitas una suscripción premium activa para usar la herramienta!",
    "subscriptionRequired": "¡Necesitas una suscripción activa para usar la herramienta!",
    "pasteCSVFirst": "Por favor, pega primero tus datos CSV de inventario.",
    "csvPasted": "CSV de inventario pegado.",
    "pasteHint": "Tip: Presiona Ctrl+V (o Cmd+V en Mac) en cualquier parte de esta página para pegar tu CSV de inventario directamente.",
    "noValidItems": "No se encontraron objetos válidos en los datos CSV. Verifica el formato.",
    "analysisComplete": "¡Análisis completado! Se encontraron {{opportunities}} oportunidades de venta para {{items}} objetos del inventario.",
    "analysisFailed": "Análisis de inventario fallido. Por favor, inténtalo de nuevo.",
    "title": "Análisis de inventario",
    "description": "Pega tu export CSV de inventario del juego a continuación. Analizaremos cada objeto en todos los reinos disponibles para encontrar las mejores oportunidades de venta.",
    "addonInstall": "Instala el addon desde",
    "addonInstallHere": "aquí",
    "csvFormatTitle": "Formato CSV esperado",
    "csvFormatNote": "Delimitado por punto y coma. Los BonusIDs están separados por dos puntos (ej.",
    "csvModifiersNote": "). Los modificadores usan",
    "csvModifiersFormat": "tipo=valor",
    "csvModifiersExample": "formato (ej.",
    "sellingRealmsTitle": "Reinos de venta para el inventario",
    "suggestedDropships": "Dropships sugeridos",
    "inventoryDataLabel": "Datos de inventario",
    "itemsDetected": "{{count}} objeto detectado",
    "itemsDetectedPlural": "{{count}} objetos detectados",
    "uploadFile": "Subir archivo",
    "analyzeButton": "Analizar {{count}} objetos",
    "analyzeInventoryButton": "Analizar inventario",
    "clearButton": "Limpiar",
    "backToInput": "Regresar a la entrada de inventario",
    "noOpportunities": "No se encontraron oportunidades de venta para los objetos de tu inventario.",
    "noOpportunitiesReason": "Esto puede ocurrir si los objetos no tienen datos de mercado TSM o no son intercambiables.",
    "tryAgain": "Intentar de nuevo",
    "exportCSV": "Exportar para FlipQueue"
  },
  "realmConfig": {
    "setupGuideLink": "Haz clic aquí para la guía de configuración de la herramienta",
    "selectRegion": "Seleccionar región actual",
    "updateBuyingRealms": "Actualizar reinos de compra para {{region}} ({{selected}} de {{total}})",
    "updateSellingRealms": "Actualizar reinos de venta para {{region}} ({{selected}} de {{max}})",
    "sellingRealmLimitTooltip": "Como suscriptor con una suscripción {{type}} solo puedes seleccionar {{max}} reinos de venta.",
    "addAllToBuying": "Agregar todos los reinos a reinos de compra",
    "removeAllFromBuying": "Eliminar todos los reinos de reinos de compra",
    "removeRussianFromBuying": "Eliminar todos los reinos rusos de reinos de compra",
    "addAllToSelling": "Agregar todos los reinos a reinos de venta",
    "removeAllFromSelling": "Eliminar todos los reinos de reinos de venta",
    "removeRussianFromSelling": "Eliminar todos los reinos rusos de reinos de venta",
    "wowAccountsTitle": "Cuentas WoW",
    "addAccount": "Agregar cuenta",
    "accountNamePlaceholder": "Nombre de cuenta (ej. WoW2)",
    "accountNameRequired": "El nombre de cuenta es obligatorio",
    "addAccountFailed": "No se pudo agregar la cuenta",
    "deleteAccountDefault": "No se puede eliminar la cuenta predeterminada",
    "deleteAccountConfirm": "¿Estás seguro? Esta cuenta se eliminará de todas las asignaciones de reinos.",
    "deleteAccountFailed": "No se pudo eliminar la cuenta",
    "updateAccountFailed": "No se pudo actualizar el nombre de cuenta",
    "assignRealmsLabel": "Asignar reinos a cuentas (un reino puede estar en varias cuentas):",
    "selectAll": "Seleccionar todo",
    "deselectAll": "Deseleccionar todo",
    "noRealmsSelected": "No hay reinos seleccionados",
    "addMoreAccounts": "Agrega más cuentas para asignar reinos a diferentes cuentas WoW.",
    "saveButton": "Guardar todos los datos",
    "missingAccountsError": "Por favor, asigna al menos una cuenta a cada reino. Faltantes: {{realms}}",
    "discordQuestion": "¿Aún tienes preguntas? Únete a nuestro Discord",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "Generador de listas TSM",
    "saveButtonDirty": "Guardar cambios •",
    "saveSettingsFailed": "No se pudo guardar la configuración",
    "unsavedTitle": "Cambios sin guardar",
    "unsavedLeaveMessage": "Tienes ajustes de reinos sin guardar. Si sales de esta página, perderás los cambios.",
    "unsavedLeaveConfirm": "Salir sin guardar",
    "unsavedStay": "Permanecer en la página",
    "saveBeforeNavTitle": "¿Guardar los cambios?",
    "saveBeforeNavMessage": "Tu selección de reinos tiene cambios sin guardar. Guárdalos para que la herramienta use tu nueva configuración.",
    "saveAndContinue": "Guardar y continuar",
    "deleteAccountTitle": "Eliminar cuenta de WoW",
    "deleteAccountMessage": "¿Eliminar la cuenta \"{{name}}\"? Se quitará de todas las asignaciones de reinos.",
    "deleteAccountConfirmButton": "Eliminar",
    "renameAccountAria": "Renombrar la cuenta {{name}}",
    "deleteAccountAria": "Eliminar la cuenta {{name}}",
    "confirmRenameAria": "Guardar el nombre de la cuenta",
    "cancelRenameAria": "Cancelar el cambio de nombre",
    "confirmAddAria": "Agregar cuenta",
    "cancelAddAria": "Cancelar la adición de cuenta"
  },
  "tsmProfile": {
    "title": "Guía de configuración de perfil TSM",
    "realmPriceAnalysis": "Análisis de precios del reino",
    "minimumPriceOperation": "Operación precio mínimo",
    "maximumPriceOperation": "Operación precio máximo",
    "normalPriceOperation": "Operación precio normal",
    "copyButton": "Copiar",
    "copiedSuccess": "¡Operación de precio TSM {{operation}} copiada al portapapeles!",
    "copyFailed": "Error al copiar al portapapeles"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "¡Necesitas una suscripción activa para usar la herramienta!",
    "watchVideoGuide": "Ver guía en video",
    "copyTSMString": "Copiar cadena TSM",
    "copyTSMFailed": "Error al copiar la cadena TSM al portapapeles",
    "videoGuideTitle": "Guía en video del generador de listas TSM",
    "emptyTitle": "No se encontraron datos de subastas",
    "emptyDescription": "Ningún dato de subastas coincide con tus reinos configurados. Revisa tu configuración de reinos o inténtalo de nuevo tras la próxima actualización de la casa de subastas.",
    "emptyConfigureButton": "Configurar reinos",
    "emptyRetryButton": "Reintentar"
  },
  "realmStats": {
    "subscriptionRequired": "¡Necesitas una suscripción activa para usar la herramienta!",
    "overallStatistics": "Estadísticas generales",
    "realmPriceAnalysis": "Análisis de precios del reino",
    "watchVideoGuide": "Ver guía en video",
    "noData": "No hay datos de reino disponibles",
    "legend": "Leyenda",
    "legendCheap": "Bastante barato (<{{ratio}})",
    "legendNormal": "Alrededor de lo normal ({{min}}-{{max}})",
    "legendExpensive": "Significativamente caro (>{{ratio}})",
    "tooltipCheap": "Esto significa que los objetos en general están más cerca del promedio de venta regional en precio. Es bastante barato comprar aquí, pero no tan bueno para vender.",
    "tooltipNormal": "Esto significa que los objetos están mezclados en relación al promedio de venta regional. Puede ser bueno para comprar y vender.",
    "tooltipExpensive": "Esto significa que los objetos en general están bastante por encima del promedio de venta regional. Es bastante caro comprar aquí y puede ser bueno para vender.",
    "colRealmName": "Nombre del reino",
    "colPopulation": "Población",
    "colAuctions": "Subastas",
    "colPriceRatio": "Ratio de precio",
    "colCheaper": "Más barato",
    "colExpensive": "Más caro",
    "colPercentCheaper": "% Más barato",
    "colPercentExpensive": "% Más caro",
    "colPercentEqual": "% Igual",
    "totalRealms": "Total de reinos",
    "totalAuctions": "Total de subastas",
    "avgPriceRatio": "Ratio de precio promedio",
    "cheaperThanRegion": "Más barato que la región",
    "totalAuctionsHistory": "Historial de subastas totales",
    "avgPriceRatioHistory": "Historial de ratio de precio promedio",
    "percentCheaperHistory": "Historial % más barato",
    "auctionsHistory": "{{realm}} - Historial de subastas",
    "priceRatioHistory": "{{realm}} - Historial de ratio de precio",
    "cheaperCountHistory": "{{realm}} - Historial de cantidad más barata",
    "expensiveCountHistory": "{{realm}} - Historial de cantidad más cara",
    "percentCheaperRealm": "{{realm}} - Historial % más barato",
    "percentExpensiveRealm": "{{realm}} - Historial % más caro",
    "percentEqualRealm": "{{realm}} - Historial % igual",
    "videoTitle": "Guía de video de la herramienta de estadísticas de reino"
  },
  "tsmDataTable": {
    "colItemName": "Nombre del objeto",
    "colCategory": "Categoría",
    "colExpansion": "Expansión",
    "colSellRate": "Tasa de venta",
    "colSaleAvg": "Promedio de venta",
    "colRegionMarketValue": "Valor de mercado regional",
    "colRegionHistorical": "Histórico regional",
    "clickToCopy": "Clic para copiar: {{name}}",
    "tooltipSaleAvg": "Precio promedio al que se ha vendido un objeto en los últimos 60 días",
    "tooltipMarketValue": "Precio promedio al que se ha publicado un objeto en los últimos 14 días en todos los reinos de tu región",
    "tooltipHistorical": "Precio promedio al que se ha publicado un objeto en los últimos 60 días en todos los reinos de tu región"
  },
  "import": {
    "confirmTitle": "Confirmar importación",
    "confirmMessage": "¿Importar {{count}} entradas a la lista de {{tab}}?",
    "confirmMessageCategory": "¿Importar {{count}} entradas a la lista de {{tab}} (categoría: {{category}})?",
    "confirmButton": "Importar"
  }
}
